import * as actType from '../actions/actions';

const initialState = {
    orderNumber: 0
}

const addOrder = (state) => {
    console.log('ADD_ORDER', state.order);
    return {    
        ...state, 
        orderNumber: ++state.orderNumber 
    }
}

const removeOrder = (state) => {
    console.log('REMOVE_ORDER', state.order);
    return {
        ...state, 
        orderNumber: state.orderNumber > 0 ? --state.orderNumber : state.orderNumber
    }
}

// const productsById = ( state = {}, action ) => {
//     switch( action.type ) {
//         case actType.
//     }
// }

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actType.ADD_TO_ORDER: return addOrder(state);
        case actType.DEC_FROM_ORDER: return removeOrder(state); 
        default: return state;
    }
}

export default reducer; 


// WEBPACK FOOTER //
// ./src/store/reducers/reducer.js